import { ga } from "@wb/ui/analytics/ga";
import { state } from "@wb/ui/analytics/state";
import { type FC, useEffect } from "react";
import { z } from "zod";

const schema = z.object({
  id: z.custom<`G-${string}`>(
    (v) => v.startsWith("G-") || "Invalid Google Analytics ID",
  ),
});

type Props = z.infer<typeof schema>;

export const GoogleAnalytics: FC<Props> = ({ id }) => {
  useEffect(() => {
    state.instances.push(ga);
  }, []);

  return (
    <>
      <script
        src={`https://www.googletagmanager.com/gtag/js?id=${id}`}
      ></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${id}');`}
      </script>
    </>
  );
};
